<template>
  <div id="PlaceholderTabContent" class="placeholder-tab-content">
    <el-row class="placeholder-row">
      <el-col v-for="(item, index) in placeholders" :key="index" :span="12" class="placeholder-col">
        <div class="placeholder-container">
          <p class="placeholder-title">
            {{ item.majorCN ? `${item.typeCN}（${item.majorCN}）`:`${item.typeCN}` }}
          </p>
          <div class="placeholder-content" :class="{'is-relate': !item.thumbnail}">
            <div v-if="!item.thumbnail" class="relate-block" @click.stop="showRelateDialog(item)">
              <span class="ft-theme"><i class="iconfont icon-wenjian-tianjia" />关联图例</span>
            </div>
            <div v-else class="img-name-block">
              <el-image :class="{'stop-status': item.status === 'TOBE_RELEASED'}" :src="$hosts.static(item.thumbnail)" fit="contain" />
              <div v-if="item.status === 'TOBE_RELEASED'" class="stop-tip">
                <span class="stop-tip-span">已停用</span>
              </div>
              <p v-if="!item.isBuildIn" class="name-row">
                <span>{{ item.name }}</span>
                <i class="del-icon iconfont icon-wenjian-shanchu ft-theme" @click="deleteRelatePlaceholder(item)" />
              </p>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PlaceholderTabContent',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      buildInPlaceholders: 'resourceDetail/buildInPlaceholders',
    }),
    placeholders() {
      return this.buildInPlaceholders
    },
  },
}
</script>

<style lang="less" scoped>
.placeholder-row{
  padding: 0 40px;
}
.placeholder-col{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.placeholder-container{
  width: 360px;
  margin-bottom: 20px;
  .placeholder-title{
    text-align: center;
    padding: 8px 0;
  }
  .placeholder-content{
    height: 256px;
    border: 1px solid @border-color;
    &.is-relate:hover{
      cursor: pointer;
      background: @theme-color-hover;
      border-color: @theme-color;
    }
  }
  .relate-block{
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .img-name-block{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .name-row{
      flex: 0 0 32px;
      padding: 0 6px;
      background: @bg-grey-light;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .del-icon{
      cursor: pointer;
    }
    .stop-status{
      opacity: 0.2;
    }
    .stop-tip{
      text-align: center;
      padding: 8px 0;
    }
    .stop-tip-span{
      padding: 2px 12px;
      background: #d8d8d8;
      color: #ffffff;
    }
  }
}
.search-row{
  text-align: right;
  padding-right: 10px;
  .keyword-input{
    width: 260px;
  }
}
.list-content{
  margin: 20px 0;
  .empty-content{
    text-align: center;
    color: @text-sub-gery;
  }
}
.list-ul{
  position: relative;
  max-height: 360px;
  overflow: auto;
  .list-li{
    float: left;
    margin: 0 10px 20px;
  }
}
.dialog-footer{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.dialog-tip{
  color: @text-main-gery;
}
</style>
